import type { GuardArgs } from 'xstate5/dist/declarations/src/guards';

import { type Context } from './context';
import { type Event } from './events';

// ─────────────────────────────────────────────────────────────────────────────

export type Guard<Params = void> = (
  args: GuardArgs<Context, Event>,
  params: Params,
) => boolean;
